// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__2pgJ5","options":"AnswerScale_options__9-HH-","selected":"AnswerScale_selected__1UDP0"};